/* eslint-disable */
import React from "react";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router-dom";
import { browserHistory } from "react-router";

// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components

import withStyles from "@material-ui/core/styles/withStyles";
// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import Sidebar from "components/Sidebar/Sidebar.jsx";

import sidebarRoutes from "routes/dashboard.jsx";

import dashboardStyle from "assets/jss/material-dashboard-react/layouts/dashboardStyle.jsx";

import image from "assets/img/sidebar-8-3.jpg";
import aclogo from "assets/img/AccuCASH_Insight_stacked_200px.png";
import cumminsLogo from "assets/img/cummins-transparent-logo149x43.png";

import httpr from "lib/httpRequest";

import { BASE_URL, AUTH_OPTIONS, isLocal, localLicenseRenewDate } from "lib/config";
import { AuthProvider, AuthConsumer } from "react-check-auth";
import ReactLoading from "react-loading";

import DateFnsUtils from "@date-io/date-fns";
import MuiPickersUtilsProvider from "material-ui-pickers/MuiPickersUtilsProvider";

const switchRoutes = (state) => (
  <Switch>

    { state.licenseAvail ?
        sidebarRoutes.map((prop, key) => {
          if (prop.redirect) {
            return <Redirect from={prop.path} to={prop.to} key={key} />;
          }
          return (
            <Route
              path={prop.path}
              component={withProps(prop.component, state)}
              key={key}
            />
          );
        }) : <div/>
  
    }
  </Switch>
);

function withProps(Component, props) {
  return function(matchProps) {
    return <Component {...props} {...matchProps} />;
  };
}

class App extends React.Component {
  constructor(props) {
    super(props);

    let logo = "";
    if (window.location.hostname.includes("carcr")) {
      logo = cumminsLogo;
    } else {
      logo = aclogo;
    }

    this.state = {
      mobileOpen: false,
      token: null,
      member: null,
      logo: logo,
      licenseAvail: true,
    };
    this.resizeFunction = this.resizeFunction.bind(this);
  }
  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };

  getRoute() {
    return this.props.location.pathname !== "/maps";
  }

  resizeFunction() {
    if (window.innerWidth >= 960) {
      this.setState({ mobileOpen: false });
    }
  }

  componentDidMount() {
    // if (window.location.href.includes("")) {
    //   const ps = new PerfectScrollbar(this.refs.mainPanel);
    // }
    // window.addEventListener("resize", this.resizeFunction);
    window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;

    if(isLocal === "true") {
      this.checkLicense();
    }
  }
  /*
  componentDidUpdate(e) {
    if (e.history.location.pathname !== e.location.pathname) {
      this.refs.mainPanel.scrollTop = 0;
      if (this.state.mobileOpen) {
        this.setState({ mobileOpen: false });
      }
    }
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeFunction);
  }*/

  checkLicense = function() {
    // check license renewal date
    let licenseRenewDate = new Date(localLicenseRenewDate);
    const timeElapsed = Date.now();
    const today = new Date(timeElapsed);

    const daysBetween = this.daysBetween(today, licenseRenewDate);
    let message = "";
    message = "License expires in " + daysBetween + " days! \nPlease contact Socal Safe ASAP for renewal.\n1-(800)334-6060";

    if (daysBetween < 1) {
      alert("License is expired!\nPlease contact Socal Safe to access Insight.\n1-(800)334-6060");
      this.setState({licenseAvail:false});
    } else if (daysBetween < 30) {
      alert(message);
    } 
  }

  daysBetween = function( date1, date2 ) {
    //Get 1 day in milliseconds
    var one_day=1000*60*60*24;
  
    // Convert both dates to milliseconds
    var date1_ms = date1.getTime();
    var date2_ms = date2.getTime();
  
    // Calculate the difference in milliseconds
    var difference_ms = date2_ms - date1_ms;
  
    // Convert back to days and return
    return Math.round(difference_ms/one_day); 
  }

  render() {
    const { classes, ...rest } = this.props;
    const { logo } = this.state;
    const authMenu = [];
    sidebarRoutes.map((route) => {
      if (route.path != "/login") {
        authMenu.push(route);
      }
    });

    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <AuthProvider
          authUrl={`${BASE_URL}/auth/verify`}
          reqOptions={AUTH_OPTIONS}
        >
          <div className={classes.wrapper}>
            <AuthConsumer>
              {({ isLoading, userInfo, error, refreshAuth }) => {
                if (userInfo === null || userInfo === undefined) {
                  return (
                    <Sidebar
                      routes={[sidebarRoutes[0]]}
                      logo={logo}
                      image={image}
                      handleDrawerToggle={this.handleDrawerToggle}
                      open={this.state.mobileOpen}
                      color="green"
                      {...rest}
                    />
                  );
                }
                return (
                  <Sidebar
                    routes={authMenu}
                    logo={logo}
                    image={image}
                    handleDrawerToggle={this.handleDrawerToggle}
                    open={this.state.mobileOpen}
                    color="green"
                    {...rest}
                  />
                );
              }}
            </AuthConsumer>

            <div className={classes.mainPanel} ref="mainPanel">
              <AuthConsumer>
                {({ isLoading, userInfo, error }) => {
                  if (userInfo === null || userInfo === undefined) {
                    return (
                      <Header
                        routes={[sidebarRoutes[0]]}
                        handleDrawerToggle={this.handleDrawerToggle}
                        {...rest}
                      />
                    );
                  }
                  if (isLocal === "true"){
                    if (!this.state.licenseAvail){
                      alert("License is expired!\nPlease contact Socal Safe to access Insight.\n1-(800)334-6060");
                      return (
                        <Header
                          routes={[sidebarRoutes[0]]}
                          handleDrawerToggle={this.handleDrawerToggle}
                          {...rest}
                        />
                      );
                    } else {
                      return (
                        <Header
                          routes={authMenu}
                          handleDrawerToggle={this.handleDrawerToggle}
                          {...rest}
                        />
                      );
                    }
                  } else {
                    return (
                      <Header
                        routes={authMenu}
                        handleDrawerToggle={this.handleDrawerToggle}
                        {...rest}
                      />
                    );
                  }
                }}
              </AuthConsumer>
              <div className={classes.content}>
                <div className={classes.container}>
                  { switchRoutes(this.state) }
                </div>
              </div>
            </div>

            <AuthConsumer>
              {({ error }) => {
                if (error) {
                  return <Redirect to="/login" />;
                }
              }}
            </AuthConsumer>
          </div>
        </AuthProvider>
      </MuiPickersUtilsProvider>
    );
  }
}

App.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(dashboardStyle)(App);



// WEBPACK FOOTER //
// ./src/layouts/Dashboard/Dashboard.jsx